export default (page) => page.$bubble(`renderTreeToIndexdevice${page.device}`);


// WEBPACK FOOTER //
// ./src/components/Navigation/onloaded.js